<app-page-header headerImage="{{ headerImage }}" extraClass="billing-page"></app-page-header>
@if (!hasData) {
  <div class="app-loader">
    <div class="u-flex-center">
      <mat-spinner color="primary" diameter="50"></mat-spinner>
    </div>
  </div>
}

<div class="billing">
  <div class="billing-content_container">
    <div class="billing_title">
      <h1 class="mat-display-small">Billing</h1>
    </div>

    <div class="content-wrapper">
      <div class="account-balance_container">
        <app-account-balance-billing-card></app-account-balance-billing-card>
      </div>

      <div class="recent-invoices_container">
        <div class="recent-invoices_title margin-bottom-desktop-header margin-bottom-mobile-header">
          <h2 class="mat-display-medium bddc-light-blue margin-bottom-desktop-header margin-bottom-mobile-header">
            Recent invoices
          </h2>
        </div>

        <div class="recent-invoices_action bddc-light-blue margin-bottom-link-desktop margin-bottom-link-mobile">
          <div class="recent-invoices_action-link">
            <span class="bddc-light-blue mat-body-medium" (click)="
                navigateTo('settings', 'recent invoices', 'payment settings')
              ">payment settings</span>
            <mat-icon class="bddc-accent">chevron_right</mat-icon>
          </div>
        </div>
      </div>

      <mat-card class="invoice-card">
        <mat-list role="list">
          @if (invoiceState === '') {
            @if (!hasData) {
              <div class="u-flex-center">
                <mat-spinner color="primary" diameter="50"></mat-spinner>
              </div>
            }
            @for (invoice of invoices; track invoice) {
              <mat-list-item class="list-item-borders">
                <div class="list-item-content-wrapper">
                  <div class="invoice-details">
                    <div class="invoice-card_title">
                      <div class="gray-blue_bold">
                        {{ invoice.invoiceNumber }}
                      </div>
                      <span [class.state_due]="invoice.state === 'Due'"
                        [class.state_partial]="invoice.state === 'Partially Paid' || invoice.state === 'Payment scheduled'"
                        [class.state_paid]="invoice.state === 'Paid'">
                        {{ invoice.state }}
                      </span>
                    </div>
                    <div class="invoice-card_date">
                      <div class="gray-blue">{{ invoice.invoiceDate }}</div>
                    </div>
                  </div>
                  <div class="button-wrapper">
                    @if (!invoice.paid && invoice.go_cardless_status !== 'Payment scheduled') {
                      <div>
                        @if (loadingStripe[invoice.id]) {
                          <button [disabled]="true" mat-raised-button background-color="white"
                            class="compact-extended-height">
                            <div class="u-flex-center">
                              <mat-spinner color="primary" diameter="20"></mat-spinner>
                            </div>
                          </button>
                        }
                        @if (!loadingStripe[invoice.id] && !hideButton && !invoice.stripe_presence) {
                          <button mat-raised-button color="primary"
                            class="compact-extended-height" (click)="payInvoice(invoice.id, invoice.invoiceTotal)">
                            PAY
                          </button>
                        }
                      </div>
                    }
                    @if (invoice.paid || invoice.go_cardless_status == 'Payment scheduled') {
                      <div class="none-button">
                      </div>
                    }
                    <div [routerLink]="['invoice_details', invoice.id]" (click)="googleEvent()"
                      class="invoice-card_amount bddc-light-blue hover-effect">
                      <span class="bddc-light-blue">&pound;{{ invoice.invoiceTotal }}</span>
                      <mat-icon class="bddc-accent">chevron_right</mat-icon>
                    </div>
                  </div>
                </div>
              </mat-list-item>
            }
          }

          @if (invoiceState !== '') {
            <div class="invoice-card_blank">
              <p class="mat-body-medium">{{ invoiceState }}</p>
            </div>
          }
        </mat-list>
      </mat-card>
    </div>
  </div>
</div>